import { type ReactNode, type FC } from "react"
import styled from "styled-components"
import Values from "values.js"

import AspectRatio from "@forento/shared/components/AspectRatio"

import { lightTextColor } from "~/utilities/styles"

type Props = {
	title: string
	thumbnailUrl: string | null
	htmlDescription: string | null
	callToAction: ReactNode
}
const Hero: FC<Props> = ({ title, htmlDescription, callToAction, thumbnailUrl }) => (
	<Container>
		<Content>
			<Details>
				<Title>{title}</Title>
				{htmlDescription && <Description dangerouslySetInnerHTML={{ __html: htmlDescription }} />}
				{callToAction}
			</Details>
			<ThumbnailContainer>
				<AspectRatio width={{ value: 100, unit: "percent" }} aspectRatio={16 / 12}>
					{thumbnailUrl ? <Thumbnail alt="Product thumbnail" src={thumbnailUrl} /> : <div />}
				</AspectRatio>
			</ThumbnailContainer>
		</Content>
	</Container>
)

export const CallToActionIcon = styled.div`
	width: 16px;
	height: 16px;
`

export const CallToActionInfo = styled.p`
	font-size: 16px;
	color: ${lightTextColor};
	font-style: italic;
`

export const CallToActionButtons = styled.div`
	display: flex;
	gap: 16px;
`

const Container = styled.div`
	@media (max-width: 999px) {
		margin: 0 16px;
	}
`

const Content = styled.div`
	background-color: ${props => new Values(props.theme.primaryColor).tint(90).hexString()};
	border-radius: 16px;
	display: flex;
	padding: 42px;
	gap: ${42 * 2}px;
	margin-bottom: 42px;
`

const Details = styled.div`
	flex: 1 0 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	gap: 22px;
`

const Title = styled.h1`
	font-weight: 500;
	font-size: 24px;
	color: #151d48;
`

const Description = styled.div`
	font-size: 16px;
	color: ${lightTextColor};
`

const ThumbnailContainer = styled.div`
	flex: 1 0 0;
	border-radius: 8px;
	overflow: hidden;

	@media (max-width: 999px) {
		display: none;
	}
`

const Thumbnail = styled.img`
	object-fit: cover;
`

export default Hero
